export enum Request2FaCodeStatus {
  Uninitialized = -1,
  Initialized = 0,
  NotConfirmed = 1,
  SmsSent = 2,
  UseAuthenticator = 3,
  Error = 4,
}
